import axios from "axios";
import Swal from "sweetalert2";

import { getFromLocalStorage } from "../utils/common-utils";
import { axiosInstance, axiosInstanceWithoutEnc } from "./axiosInstance";

export const LoginUser = async (payload) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/auth-manager/auth/v1/login`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const ForgetPasswordSendLink = async (payload) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/auth-manager/user/v1/forget-password/${payload?.email}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const VerifyEmail = async (payload) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/auth-manager/auth/v1/verify-email/${payload?.token}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const LogoutUser = async (payload) => {
  try {
    const res = await axiosInstance.get(
      `/auth-manager/auth/v1/logout/${payload?.userId}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const Get2FADet = async (payload) => {
  try {
    const res = await axiosInstance.get(
      "/auth-manager/auth/v1/get-twofadetails",
      {
        headers: {
          "Content-Type": "text/plain",
          userId: payload?.userId,
        },
      }
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const Generate2Fa = async () => {
  try {
    const res = await axiosInstance.get("/auth-manager/auth/v1/twofa-generate");
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const Removal2FA = async () => {
  try {
    const res = await axiosInstance.get("/auth-manager/auth/v1/twofa-remove");
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const UpdatePassword = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/auth/v1/change-password",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetAllItemsSku = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/item/v1/fetch",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetAllItemsSkubyUser = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/item/v1/fetch-by-category",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetAllCategoriesList = async () => {
  try {
    const res = await axiosInstance.get(
      "/auth-manager/category/v1/get-category-list"
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const CreateItemSku = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/item/v1/create",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const ChangePasswordPrivate = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/password/update",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const AddCategory = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/category/v1/create",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const AddColour = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/color/v1/create",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const AddSize = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/size/v1/create",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const ChangeItemStatus = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/item/v1/status-change",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetActiveDeActiveItemCount = async () => {
  try {
    const res = await axiosInstance.get("/auth-manager/item/v1/count");
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetActiveDeActiveBranchCount = async () => {
  try {
    const res = await axiosInstance.get("/auth-manager/branch/v1/count");
    return res;
  } catch (error) {
    console.log("error", error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const VerifyOtpProfile = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/auth/v1/google/pin-verify",
      payload
    );
    return res;
  } catch (error) {
    console.log("error", error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const VerifyOtpAuth = async (payload) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/auth-manager/auth/v1/google/pin-verify`,
      payload,
      {
        headers: {
          "Content-Type": "text/plain",
          userId: getFromLocalStorage("userData")?.id,
        },
      }
    );
    return res;
  } catch (error) {
    console.log("error", error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const ChangeBranchStatus = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/branch/v1/status-change",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const Get2FaAuthDet = async () => {
  try {
    const res = await axiosInstance.get(
      "/auth-manager/auth/v1/google-autenticator"
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const CreateNewBranch = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/branch/v1/create",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetAllBranches = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/branch/v1/fetch",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const createCountryOperator = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/default/v1/add/country",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetAllRoleList = async () => {
  try {
    const res = await axiosInstance.get(
      `/auth-manager/user/v1/fetch/existinggroup/${
        getFromLocalStorage("userData")?.id
      }`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetCountries = async () => {
  try {
    const res = await axiosInstance.get(`/auth-manager/cp/v1/country/list`);
    return res;
  } catch (error) {
    return error;
  }
};

export const GetSuppliersWithoutPag = async (payload) => {
  try {
    const res = await axiosInstance.get(
      "/auth-manager/supplier/v1/fetch-suppliers",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const fetchReport = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/report-manager/revenue/report/v1/new/fetch",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const fetchCountryOperatorList = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/default/v1/fetch/country",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const countryOperatorChangeStatus = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/default/v1/statusChange",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const fetchSubscriberReport = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/report-manager/subscribe/report/v1/record/base",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const UpdateBranch = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `/auth-manager/branch/v1/update/${payload?.branchId}`,
      payload?.data
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CreatePurchaseOrderBranch = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/purchase-order/v2/create",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetActiveDeActivePurchaseOrderCount = async () => {
  try {
    const res = await axiosInstance.get("/auth-manager/api/v1/count-po");
    return res;
  } catch (error) {
    console.log("error", error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const ChangePurchaseOrderStatus = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/purchase-order/v1/status-change",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const ChangePurchaseOrderStatusFO = async (payload) => {
  try {
    const res = await axiosInstanceWithoutEnc.post(
      "/auth-manager/purchase-order/v1/status-change-fo",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetAllPurchaseOrders = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/api/v1/fetch-po",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetAllItemsWithoutPage = async (payload) => {
  try {
    const res = await axiosInstance.get(
      "/auth-manager/item/v1/fetch-list",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getAllRejectedPOReason = async (payload) => {
  try {
    const res = await axiosInstance(
      `/auth-manager/api/v1/reasons/${payload?.type}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const UpdatePurchaseOrderBranch = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `/auth-manager/purchase-order/v1/update`,
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CreateNewSupplier = async (payload) => {
  try {
    const res = await axiosInstanceWithoutEnc.post(
      "/auth-manager/supplier/v1/create",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const UpdateSUpplier = async (payload) => {
  try {
    const res = await axiosInstanceWithoutEnc.post(
      "/auth-manager/supplier/v1/update",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetallSuppliers = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/supplier/v1/fetch",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetSuppliersByBranchId = async (payload) => {
  try {
    const res = await axiosInstance.get(
      `/auth-manager/api/v1/fetch-suppliers-by-branch?branchId=${payload?.branchId}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const ChangeStatus = async (payload) => {
  console.log(payload, "loopss");
  try {
    const res = await axiosInstance.post(
      "/auth-manager/supplier/v1/status-change",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CounntValue = async () => {
  try {
    const res = await axiosInstance("/auth-manager/supplier/v1/count");
    return res;
  } catch (error) {
    return error;
  }
};

export const GetAllStates = async () => {
  try {
    const res = await axiosInstance("/auth-manager/state/v1/fetch");
    return res;
  } catch (error) {
    return error;
  }
};

export const GetUserDetails = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `/auth-manager/user/v1/fetch-by-id`,
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetAllCity = async (citycode) => {
  try {
    const res = await axiosInstance(`/auth-manager/city/v1/fetch/${citycode}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const GetAllPincode = async (pincode) => {
  try {
    const res = await axiosInstance(
      `/auth-manager/localcity/v1/fetch/${pincode}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CreateBusinessUnit = async (payload) => {
  try {
    const res = await axiosInstanceWithoutEnc.post(
      "/auth-manager/business-unit/v1/create",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const CreateClientApi = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/client/v1/create",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const EditBusinessUnit = async (payload) => {
  try {
    const res = await axiosInstanceWithoutEnc.post(
      "/auth-manager/business-unit/v1/update",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const UpdateClient = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/client/v1/update",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetallUsers = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/fetch",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const CounntValueUser = async () => {
  try {
    const res = await axiosInstance.post("/auth-manager/user/v1/count");
    return res;
  } catch (error) {
    return error;
  }
};
export const getCountryCodeList = async () => {
  try {
    const res = await axiosInstance("/auth-manager/auth/v1/country/list"); // Your actual API endpoint
    return res;
  } catch (error) {
    throw error;
  }
};

export const CreateNewRole = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/create",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const CreateDND = async (payload) => {
  try {
    const res = await axiosInstance.post("/auth-manager/dnd/v1/save", payload);
    return res;
  } catch (error) {
    return error;
  }
};
export const findCustomerCreDetails = async (payload) => {
  try {
    const res = await axiosInstance.post("/customer-care/customercare/v1/find/msisdn/details", payload);
    return res;
  } catch (error) {
    return error;
  }
};
export const findDNDList = async (payload) => {
  try {
    const res = await axiosInstance.post("/auth-manager/dnd/v1/find", payload);
    return res;
  } catch (error) {
    return error;
  }
};
export const DeleteDND = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/dnd/v1/delete",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const DeleteOperator = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/default/v1/deleteOperator",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CreateNewUser = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/create",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const addOperator = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/default/v1/add/operator",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const downloadSubscriberRevenueReport = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/report-manager/revenue/report/v1/download",
      payload
    );
    console.log("resssssssssssssss", res);
    return res;
  } catch (error) {
    return error;
  }
};
export const submitProductDetails = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/product/v1/create",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const submitBillingDetails = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/product/v1/create/billing",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const submitKeywordDetails = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/product/v1/keyword/config",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const submitFallbackDetails = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/product/fallback/v1/create",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const submitChargingConfig = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/product/v1/charging/configuration",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const updateFallbackDetails = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/product/fallback/v1/update",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const submitSmsDetails = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/product/v1/create/sms",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const submitPartnerNotification = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/product/v1/create/notifyurl",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const submitCustomerNotification = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/product/v1/custNotify",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const updateUserProfile = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/user/update",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CreateNewService = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/service/v1/create",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const UpdateService = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/service/v1/update",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CreateNewCp = async (payload) => {
  try {
    const res = await axiosInstance.post("/auth-manager/cp/v1/create", payload);
    return res;
  } catch (error) {
    return error;
  }
};
export const generateClientSecret = async (id) => {
  try {
      const response = await axiosInstance(`/auth-manager/cp/v1/generate-clientsecret/${id}`);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const BlockCpUser = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/cp/v1/blocked/cp",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const BlockCpService = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/service/v1/statusChange",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const UpdateCp = async (payload) => {
  try {
    const res = await axiosInstance.post("/auth-manager/cp/v1/update", payload);
    return res;
  } catch (error) {
    return error;
  }
};

export const CreateJob = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/recruit-request-management/job-request/v1/save",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const UpdateUser = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/user/update",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const SaveAsDraftUser = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/create-draft",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const UpdateRole = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/update",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const ChangeStatusUser = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/status-change",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const ChangePasswordUser = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/change-password",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const CreateRateList = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/supplier/v1/add-rate",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CreateSellingRateList = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/branch/v1/add-sellingprice",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const UpdateRateList = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/supplier/v1/update-ratelist",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const FetchRateList = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/supplier/v1/fetch-ratelist",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const FetchSellingRate = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/branch/v1/fetch-branch-items",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const FetchCommonSkusAdmin = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/branch/v1/fetch-common-skus",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetAllSupplierSellingRates = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/branch/v1/fetch-supplier-rates",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const UpdateSellingRateList = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/branch/v1/update-ratelist",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const DownloadExcel = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/api/v1/download",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CreateSalesOrderAPi = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/sales-order/v1/create",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CreateSalesOrderAPiForSales = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/sales-order/v1/create-agent-stock",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetALLSalesOrders = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/sales-order/v1/fetch",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetALLSalesManage = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/sales-order/v1/fetch-saleagent-stock",
      payload
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const GetALLSalesOrdersForSales = async () => {
  try {
    const res = await axiosInstance("/auth-manager/sales-order/v1/count");
    return res;
  } catch (error) {
    return error;
  }
};

export const SalesOrderTabs = async () => {
  try {
    const res = await axiosInstance("/auth-manager/sales-order/v1/count");
    return res;
  } catch (error) {
    return error;
  }
};

export const SalesOrderTabsStock = async (payload) => {
  try {
    const res = await axiosInstance(
      `/auth-manager/sales-order/v1/stock-allocation-type-count?type=${payload}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getallMaintabsStock = async () => {
  try {
    const res = await axiosInstance(
      "/auth-manager/sales-order/v1/stock-allocation-type"
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getallTabsType = async () => {
  try {
    const res = await axiosInstance("/auth-manager/sales-order/v1/sale-type");
    return res;
  } catch (error) {
    return error;
  }
};

export const getallTabsTypepayment = async () => {
  try {
    const res = await axiosInstance(
      "/auth-manager/sales-order/v1/payment-type"
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const ChangeSalesOrderStatus = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/sales-order/v1/status-change",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const getAllCategoriesConf = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/category/v1/get-categories",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const getAllColorsConf = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/color/v1/get-color",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const getAllSizeConf = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/size/v1/get-size",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const FetchMarqueData = async () => {
  try {
    const res = await axiosInstance.get(
      "/auth-manager/marque/v1/get-marque-list"
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const FetchPOReportAdmin = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/report/v1/purchase-order",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetAllRoles = async () => {
  try {
    const res = await axiosInstance.post("/auth-manager/user/v1/get-roles");
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const GetAllSelectorValuesInJobs = async () => {
  try {
    const res = await axiosInstance.get(
      "/recruit-request-management/job-request/v1/selectors/list"
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetAllBussinessUnit = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/business-unit/v1/fetch",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetAllData = async () => {
  try {
    const res = await axiosInstance.get(
      `/cp/v1/active/record/${getFromLocalStorage("userData")?.id}`
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetAccountStatusData = async (payload) => {
  try {
    const res = await axiosInstance.post(`/auth-manager/user/v1/list`, payload);
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const GetServicePackageData = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `/product-service/service/v1/single/search`,
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const GetCustomerSubscriptionData = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `/customer-care/customercare/v1/find/msisdn/charging/details`,
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetContentProviderData = async (payload) => {
  try {
    const res = await axiosInstance.post(`/auth-manager/cp/v1/list`, payload);
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const GetContentProviderDataNew = async (payload) => {
  try {
    const res = await axiosInstance.post(`/auth-manager/cp/v1/cp/list`, payload);
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const envStatusChange = async (payload) => {
  try {
    const res = await axiosInstance.post(`/product-service/service/v1/environment/status`, payload);
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetServicesData = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `/product-service/service/v1/cp/find`,
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetAllClient = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/client/v1/fetchAll",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetBussinessUnitCount = async () => {
  try {
    const res = await axiosInstance.get("/auth-manager/business-unit/v1/count");
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetAccountStatusCount = async () => {
  try {
    const res = await axiosInstance.get(
      `/auth-manager/user/v1/tabs?userId=${getFromLocalStorage("userData")?.id}`
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const GetIntegrationDocument = async () => {
  try {
    const res = await axiosInstance.get(
      `/auth-manager/document/v1/fetch/details/${getFromLocalStorage("userData")?.id}`
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const GetApiAccessDetails = async (payload) => {
  try {
    const res = await axiosInstance.get(
      `/auth-manager/cp/v1/generate-clientsecret/${payload}`
    );
    return res;
  } catch (error) {
    // Swal.fire({
    //   icon: "error",
    //   title: "Oops...",
    //   text: "Something Went Wrong",
    // });
  }
};

export const GetContentProviderCount = async () => {
  try {
    const res = await axiosInstance.get("/auth-manager/cp/v1/tabs");
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetCreateServiceCount = async (payload) => {
  try {
    const res = await axiosInstance.get(
      `/product-service/service/v1/tabs?cpId=${payload?.cpId}`
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const GetClient = async () => {
  try {
    const res = await axiosInstance.get("/auth-manager/client/v1/count");
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetUsersCount = async () => {
  try {
    const res = await axiosInstance.get("/auth-manager/user/v1/count");
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetFlags = async () => {
  try {
    const res = await axiosInstance.get("/auth-manager/api/v1/country");
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const StatusChangeBussinessUnit = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/business-unit/v1/status-change",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const StatusChangeClient = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/client/v1/changeStatus",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const StatusChangeUser = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/user/statusChange",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const ApproveRejectUser = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/approve/reject",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const updateProductDetails = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/product/v1/update",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const StatusChangeServicePackage = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/product-service/product/v1/statusChange",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const fetchOperator = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/default/v1/fetch/country/operator",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const UnblockCp = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/cp/v1/unblocked/cp",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const GetAllUsers = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/fetch",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const getMidDashboardData = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/dashboard/v1/mid-card/data",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const getBarGraphData = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/dashboard/v1/graph/data",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const getSecondBarGraphData = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/dashboard/v1/sub-unsub/data",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};
export const resetPassword = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/auth-manager/user/v1/verify/password/link",
      payload
    );
    return res;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong",
    });
  }
};

export const getCountriesApi = async () => {
  try {
    const response = await axios.get("/api/countries"); // Adjust the endpoint according to your API
    return response;
  } catch (error) {
    throw error;
  }
};
export const getDashboarFirstCardsdData = async () => {
  try {
    const response = await axiosInstance.get("/auth-manager/dashboard/v1/card/count"); // Adjust the endpoint according to your API
    return response;
  } catch (error) {
    throw error;
  }
};
export const getCountryListGragh = async () => {
  try {
    const response = await axiosInstance.get("/auth-manager/dashboard/v1/country/data"); // Adjust the endpoint according to your API
    return response;
  } catch (error) {
    throw error;
  }
};
export const getCountryOperator = async () => {
  try {
    const response = await axiosInstance.get("/auth-manager/dashboard/v1/country/operator/list"); // Adjust the endpoint according to your API
    return response;
  } catch (error) {
    throw error;
  }
};
export const getPieChartData = async () => {
  try {
    const response = await axiosInstance.get("/auth-manager/dashboard/v1/pie-chart/data"); // Adjust the endpoint according to your API
    return response;
  } catch (error) {
    throw error;
  }
};
